<template>
  <div>
    <div class="w-100 d-inline-block bg-book-banner-image">
      <div class="container autoContent">
        <div class="row margin-top-3 margin-bottom-3">
          <div class="col-12">
            <div class="w-50 d-block text-center m-auto booking-banner position-relative w-xs-100 w-sm-100 w-md-100 w-ipad-100">
              <h1 class="text-black fw-bold text-full-28 family-grand-stander margin-bottom-2 margin-top-2" data-bs-toggle="modal" data-bs-target="#AddressDetailModal">
                Blog
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container autoContent">
      <div class="row margin-top-3 margin-bottom-3">
        <div class="col-xl-8 col-12 col-sm-8 col-md-8 
        col-lg-8">
          <div class="w-100 d-inline-block bg-introduction padding-3 rounded-4 padding-bottom-2">
            <div class="row">
              <div v-for="blog in displayedMainBlogs" :key="blog.id" class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6 margin-bottom-2">
                <div class="w-100 d-inline-block blog-card padding-2 bg-white rounded-4">
                  <div class="card w-100 d-inline-block position-relative border-0">
                    <img class="w-100 rounded-3" 
                          v-lazy="$getImageUrl(blog.featured_image)" 
                          alt="" 
                        />
                    <a class="text-white text-size-12 text-full-12 bg-blue position-absolute rounded-3 family-inter-bold fw-bold pets-btn" href="javascript:void(0)">
                      {{ blog.category?.name || 'Uncategorized' }}
                    </a>
                    <div class="card-body padding-2 pb-0">
                      <h5 class="card-title text-full-13 text-size-13 text-black family-inter-light fw-bold mb-0">
                        {{ blog.title }}
                      </h5>
                      <a href="javascript:void(0)" class="text-green text-full-12 text-size-12">
                        <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="calendar" />
                        {{ formatDate(blog.published_at) }}
                      </a>
                      <p class="card-text text-full-12 text-size-12 text-black family-inter-light mb-0">
                         {{ stripHtml(blog.content).slice(0, 200) }}...
                      </p>
                      <a href="javascript:void(0)" class="btn bg-blue margin-top-2 text-white text-size-12 text-full-12 px-3 py-1 rounded-2">
                        See More
                      </a>
                      <router-link :to="`/blog/${blog.slug}`" class="circle-anchor position-absolute">
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Show "No blogs found" message when category filter returns no results -->
              <div v-if="displayedMainBlogs.length === 0 && selectedCategory" class="col-12 text-center">
                <p class="text-black text-size-16 family-inter-light">No blogs found in this category.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-12 col-sm-4 col-md-4 
        col-lg-4 mt-xl-0 mt-3 mt-md-0">
          <div class="w-100 d-inline-block bg-introduction padding-3 rounded-4">
            <p class="text-black text-size-13 family-inter-light text-full-13 fw-bold margin-bottom-1">
              Search
            </p>
            <form>
              <div class="w-100 d-inline-block input-blog position-relative">
                  <input
                      v-model="searchQuery"
                      type="text"
                      class="w-100 d-inline-block bg-white rounded-2 text-size-16 text-full-13 form-control border-0 h-40 padding-left-4 padding-right-4"
                      placeholder="Search"
                      @input="filterBlogs"
                    />
                 <a class="position-absolute search-icon" href="javascript:void(0)">
                   <img src="@/assets/images/search-blog-icon.svg" alt="">
                 </a>
                 <a class="position-absolute export-icon" href="javascript:void(0)">
                   <img src="@/assets/images/direct-right-icon.svg" alt="">
                 </a>
              </div>
            </form>
            <div class="w-100 d-inline-block bg-gallery margin-top-2 categories-bg border-bottom">
              <p class="text-black text-size-13 family-inter-light text-full-13 fw-bold margin-bottom-1 padding-left-3 padding-right-3 padding-top-2">
                Categories
              </p>
            </div>
            <div class="w-100 d-inline-block bg-white categories-service-bg padding-bottom-2">
              <ul class="w-100 d-inline-block mb-0 ps-0">
                <!-- Show All Categories option -->
                <li class="border-bottom w-100 d-inline-block">
                  <a 
                    @click="selectCategory(null)" 
                    :class="['text-black text-size-12 text-full-11 family-inter-light fw-bold pading-bottom-1 padding-right-3 padding-left-3 padding-top-1 padding-bottom-1 w-100 d-inline-block', selectedCategory === null ? 'bg-light' : '']" 
                    href="javascript:void(0)"
                  >
                    <span class="d-inline-block me-1 bg-black dot-icon rounded-5"></span>
                    All Categories
                  </a>
                </li>
                <!-- Dynamic categories from API -->
                <li v-for="category in categories" :key="category.id" class="border-bottom w-100 d-inline-block">
                  <a 
                    @click="selectCategory(category.id)" 
                    :class="['text-black text-size-12 text-full-11 family-inter-light fw-bold pading-bottom-1 padding-right-3 padding-left-3 padding-top-1 padding-bottom-1 w-100 d-inline-block', selectedCategory === category.id ? 'bg-light' : '']" 
                    href="javascript:void(0)"
                  >
                    <span class="d-inline-block me-1 bg-black dot-icon rounded-5"></span>
                    {{ category.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
            <div class="w-100 d-inline-block bg-green bg-recent-post margin-top-2">
               <p class="text-white text-size-13 family-inter-light text-full-13 fw-bold mb-0 padding-top-2 padding-bottom-2 padding-left-3 padding-right-3">
                 {{ searchQuery ? 'Search Results' : 'Recent Post' }}
               </p>
            </div>
            <div class="w-100 d-inline-block bg-introduction padding-3 padding-top-2 recent-service-bg">
              <div v-for="latestBlog in displayedLatestBlogs" :key="latestBlog.id"  class="w-100 d-inline-block blog-card padding-2 bg-white rounded-4 margin-top-2">
                   <div class="card w-100 d-inline-block position-relative border-0">
                       <img class="w-100 rounded-3" 
                          v-lazy="$getImageUrl(latestBlog.featured_image)" 
                          alt="" 
                        />
                      <a class="text-white text-size-12 text-full-12 bg-blue position-absolute rounded-3 family-inter-bold fw-bold pets-btn-2" href="javascript:void(0)">
                        {{ latestBlog.category?.name || 'Uncategorized' }}
                      </a>
                      <div class="card-body padding-2 pb-0">
                        <h5 class="card-title text-full-13 text-size-13 text-black family-inter-light fw-bold mb-0">
                          {{ latestBlog.title }}
                        </h5>
                        <a href="javascript:void(0)" class="text-green text-full-12 text-size-12">
                          <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="">
                          {{ formatDate(latestBlog.published_at) }}
                        </a>
                        <p class="card-text text-full-12 text-size-12 text-black family-inter-light">
                          {{ stripHtml(latestBlog.content).slice(0, 200) }}...
                        </p>
                        <a href="javascript:void(0)" class="btn bg-blue margin-top-2 text-white text-size-12 text-full-12 px-3 py-1 rounded-2">
                        See More
                      </a>
                        <router-link :to="`/blog/${latestBlog.slug}`" class="circle-anchor position-absolute">
                      </router-link>
                      </div>
                    </div>
                </div>
                <!-- Show "No results found" message in sidebar when search returns no results -->
                <div v-if="displayedLatestBlogs.length === 0 && searchQuery" class="w-100 d-inline-block text-center margin-top-2">
                  <p class="text-black text-size-14 family-inter-light">No matching blogs found.</p>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
        <li class="float-start margin-right-2">
          <router-link class="text-black text-size-14 medium-family text-full-13" to="/"><i class="fa fa-home nav-color" aria-hidden="true"></i> Home /</router-link>
        </li>
        <li class="float-start">
          <router-link class="text-black text-size-14 medium-family text-full-13" to="/services/">Services</router-link>
        </li>
      </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blogBannerComponent',
  data() {
    return {
      blogs: [],
      latestBlogs: [],
      categories: [],
      filteredLatestBlogs: [],
      filteredMainBlogs: [],
      searchQuery: '',
      selectedCategory: null,
    };
  },
  computed: {
    // Computed property to determine which blogs to display in the sidebar
    displayedLatestBlogs() {
      return this.searchQuery ? this.filteredLatestBlogs : this.latestBlogs;
    },
    // Computed property to determine which blogs to display in the main section
    displayedMainBlogs() {
      if (this.selectedCategory === null) {
        return this.blogs; // Show all blogs when no category is selected
      } else {
        return this.filteredMainBlogs; // Show filtered blogs by category
      }
    }
  },
  mounted() {
    this.getBlogs();
    this.getCategories();
  },
  methods: {
    async getBlogs() {
      try {
        // Send a POST request with the website name in the body
        const response = await this.$axios.post('/get-all-blogs', {
          website_name: this.$websiteName,  // Include website name in the request body
          status: 'published',
        });
        
        if (response.data.status === "success") {
          this.blogs = response.data.blogs;
          this.latestBlogs = response.data.latest_blogs;
          console.log("Blogs fetched successfully:", this.blogs);
        } else {
          console.error("Failed to fetch blogs:", response.data);
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    },
    async getCategories() {
      try {
        // Send a POST request to get categories
        const response = await this.$axios.post('/get-categories', {
          website_name: this.$websiteName,
        });
        
        if (response.data.status === "success") {
          this.categories = response.data.categories;
          console.log("Categories fetched successfully:", this.categories);
        } else {
          console.error("Failed to fetch categories:", response.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },
    selectCategory(categoryId) {
      this.selectedCategory = categoryId;
      
      if (categoryId === null) {
        // Show all blogs
        this.filteredMainBlogs = [];
      } else {
        // Filter blogs by selected category
        this.filteredMainBlogs = this.blogs.filter(blog => 
          blog.category && blog.category.id === categoryId
        );
      }
    },
    stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      }).format(date);
    },
    filterBlogs() {
      if (!this.searchQuery.trim()) {
        this.filteredLatestBlogs = [];
        return;
      }
      
      const query = this.searchQuery.toLowerCase();
      // Filter only from latestBlogs array
      this.filteredLatestBlogs = this.latestBlogs.filter(blog =>
        blog.title.toLowerCase().includes(query) ||
        this.stripHtml(blog.content).toLowerCase().includes(query) ||
        (blog.category?.name && blog.category.name.toLowerCase().includes(query))
      );
    },
  }
}
</script>

<style scoped>
.bg-light {
  background-color: #f8f9fa !important;
}
</style>
